import React from 'react';
import Header from './components/Header';
import Events from './components/Events';
import DateSimulation from './components/DateSimulation';
import { useParams } from 'react-router-dom';
import Map from './components/Map';
import EventSlideout from './components/EventSlideout';
var App = function App(props) {
  var params = useParams();
  var eventType = params.type ? params.type : nycjwEventSettings.selected_event_type;
  return /*#__PURE__*/React.createElement("div", {
    className: "App"
  }, nycjwEventSettings.content && /*#__PURE__*/React.createElement("div", {
    className: "event-main-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inner-content",
    dangerouslySetInnerHTML: {
      __html: nycjwEventSettings.content
    }
  })), nycjwEventSettings.is_admin && /*#__PURE__*/React.createElement(DateSimulation, null), /*#__PURE__*/React.createElement(Header, props), /*#__PURE__*/React.createElement(Events, props), (params.event || params.type === 'virtual' && params.cat && params.cat !== 'instagram' || params.type === 'virtual' && params.cat === 'instagram' && params.event) && /*#__PURE__*/React.createElement(EventSlideout, null), /*#__PURE__*/React.createElement(Map, null));
};
export default App;